import { useHistory, useParams } from 'react-router-dom';
import { path } from 'app/utils/path';
import { useModal } from 'app/context/Modal';
import { _t } from 'app/utils/i18n';
import { getFromLocalStorage, constants } from './localStorage';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { TMutation } from 'app/Requests/types';
export const useHandleNavigateInfluencerOrEntity = () => {
  const params = useParams<any>();
  const modal = useModal();
  const history = useHistory();
  const modules = getFromLocalStorage(constants.AUTHORIZED_MODULES);
  const handleInfluencerOrEntity = (influencerData?: any) => {
    const currentInfluencer = influencerData;
    if (currentInfluencer?.influencer_id == params?.id) return undefined;
    let url;
    if (currentInfluencer?.is_entity && currentInfluencer?.influencer_id)
      url = `${path.entities.ANALYZED_ENTITIES_DETAILS_URI}/${currentInfluencer?.influencer_id}`;

    if (currentInfluencer?.is_influencer && currentInfluencer?.influencer_id)
      url = `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${currentInfluencer?.influencer_id}`;

    if (
      !currentInfluencer?.is_influencer &&
      !currentInfluencer?.is_entity &&
      currentInfluencer?.influencer_id
    )
      url = `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${currentInfluencer?.influencer_id}`;
    if (url) {
      if (
        (!modules.includes('INFLUENCERS') &&
          currentInfluencer?.is_influencer) ||
        (!modules.includes('ENTITIES') && currentInfluencer?.is_entity)
      ) {
        modal.show({
          isAlternative: true,
          message: _t(`basic:you_are_not_authorize`),
        });
      } else {
        history.push(url, {
          prevPathname: history.location.pathname,
        });
        history.go(0);
      }
    }
  };
  return [handleInfluencerOrEntity];
};

export const useOpenModalToAddUserAsInfluencer = (
  storeMutation: ({ username }: TMutation<string>) => Promise<any>,
) => {
  const history = useHistory();
  const { mutateAsync: addInfluncerNameMutateAsync } = useMutation(
    storeMutation,
    {
      onSuccess: (data: any) => {
        modal.hide();
        history.push(
          data?.is_entity
            ? `${path.entities.UN_ANALYZED_ENTITIES_DETAILS_URI}/${data?.id}`
            : `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`,
        );
        toast.success(<span>{_t('influencers:added_influencer')}</span>);
      },
      onError: (err: any) => {
        modal.hide();
        toast.error(<span>{err?.response?.data?.message}</span>);
      },
    },
  );
  const modal = useModal();
  const openModalToAddUserAsInfluencer: any = (
    username: string,
    url: string,
    openText: string,
    isChannel: string,
  ) => {
    const modules = getFromLocalStorage(constants.AUTHORIZED_MODULES);

    modules.includes('INFLUENCERS')
      ? modal.show({
          message: _t('hashtags:add_influencer_as_unanalyzes'),
          onOk: async () => {
            await addInfluncerNameMutateAsync(
              isChannel
                ? { remote_id: username }
                : {
                    username,
                  },
            );
          },
          openLink: url,
          linkText: openText,
        })
      : modal.show({
          isAlternative: true,
          message: _t(`basic:you_are_not_authorize`),
        });
  };
  return [openModalToAddUserAsInfluencer];
};
